import type { Users } from '@/entities/public/users';
import { USER_TYPE } from '../constant';
import { checkEmailFormat } from './checkEmailChar';

export const checkUserVerified = (user: Pick<Users, 'id' | 'email' | 'user_type'>) => {
  return user.user_type === USER_TYPE.CUSTOMER && checkEmailFormat(user.email);
};
